import { call, all } from 'redux-saga/effects';
import { watchGetDataConfirm, watchGetDataPlanHanldeStep } from './confirmSaga';
//IndexImportHygen

export default function* rootConfirmPageSaga() {
  yield all([
    call(watchGetDataConfirm),
    call(watchGetDataPlanHanldeStep)
    //IndexUsingHygen
    ])
}